import {useQuery, type UseQueryOptions} from '@tanstack/react-query'
import {type AxiosError} from 'axios'

import {riskSurveyQueries} from '../../api'
import type {SortDirection} from '../../helpers'
import type {PaginatedResponse, ReportSummaryDto} from '../../types'

import {riskSurveyQueryKeys} from './riskSurveyQueryKeys'

export type ReportListParams = {
  upmId?: string
  page?: number
  pageSize?: number
  includeArchived?: boolean
  sortBy?: string
  sortDir?: SortDirection
}

export const useReports = (
  params: ReportListParams,
  options?: Omit<
    UseQueryOptions<PaginatedResponse<ReportSummaryDto>, AxiosError>,
    'queryKey' | 'queryFn'
  >
) => {
  return useQuery<PaginatedResponse<ReportSummaryDto>, AxiosError>({
    queryKey: riskSurveyQueryKeys.reports.list(params),
    queryFn: ({signal}) => riskSurveyQueries.getReports(params, signal),
    staleTime: 30_000,
    gcTime: 300_000,
    ...options
  })
}
